import './ccf-dashboard-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfDashboardIconProps extends SvgIconProps  {}
/**
 * Component returns Cxone logo
 * @param props - CcfCxoneIconProps
 * @example
 * @returns
 */
export function CcfDashboardIcon(props: CcfDashboardIconProps) {
  return (
    <SvgIcon {...props} >
      <path d="M18.2119 0.768738H1.28877C0.826894 0.768738 0.52002 1.07686 0.52002 1.53749V17.6912C0.52002 18.5375 1.21189 19.2294 2.05814 19.2294H17.4431C18.2894 19.2294 18.9813 18.5375 18.9813 17.6912V1.53749C18.9813 1.07561 18.6731 0.768738 18.2125 0.768738H18.2119ZM17.4419 17.6919H2.05689V2.30686H17.4419V17.6919ZM5.13502 15.385C5.52002 15.385 5.90377 15 5.90377 14.6162V11.5394C5.90377 11.1544 5.51877 10.7706 5.13502 10.7706C4.75127 10.7706 4.36627 11.1556 4.36627 11.5394V14.6162C4.36627 15.0012 4.75127 15.385 5.13502 15.385ZM8.21189 15.385C8.59689 15.385 8.98064 15 8.98064 14.6162V6.92436C8.98064 6.53936 8.59564 6.15561 8.21189 6.15561C7.82814 6.15561 7.44314 6.54061 7.44314 6.92436V14.6162C7.44314 15.0012 7.82814 15.385 8.21189 15.385ZM11.2881 15.385C11.6731 15.385 12.0569 15 12.0569 14.6162V8.46249C12.0569 8.07749 11.6719 7.69374 11.2881 7.69374C10.9044 7.69374 10.5194 8.07874 10.5194 8.46249V14.6162C10.5194 15.0012 10.9044 15.385 11.2881 15.385ZM14.365 15.385C14.75 15.385 15.1338 15 15.1338 14.6162V5.38499C15.1338 4.99999 14.7488 4.61624 14.365 4.61624C13.9813 4.61624 13.5963 5.00124 13.5963 5.38499V14.6162C13.5963 15.0012 13.9813 15.385 14.365 15.385Z" fill="#3F5C69"/>
      </SvgIcon>
  );
}

export default CcfDashboardIcon;
